import type { CommunityResponse } from "@community-analytics/shared";

import { cn } from "@shared/lib";

export interface CommunitySelectorProps {
  communities: ReadonlyArray<CommunityResponse>;
  activeCommunityId: string | null;
  onSelect: (id: string) => void;
  /** Accessible label, e.g. "Active community". Externalized for i18n. */
  label: string;
  className?: string;
}

/**
 * Native <select> driving the active-community store. A native control is
 * the right call for a Mini App: it gets the OS-native picker on iOS and
 * Android (which Telegram WebViews defer to), it's keyboard-accessible by
 * default, and it ships zero KB of additional JS.
 */
export function CommunitySelector({
  communities,
  activeCommunityId,
  onSelect,
  label,
  className,
}: CommunitySelectorProps) {
  return (
    <label className={cn("flex flex-col gap-1", className)}>
      <span className="sr-only">{label}</span>
      <select
        aria-label={label}
        value={activeCommunityId ?? ""}
        onChange={(e) => onSelect(e.currentTarget.value)}
        className={cn(
          "h-10 rounded-md border border-input bg-background px-3 text-sm font-medium",
          "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring",
        )}
      >
        {communities.map((c) => (
          <option key={c.id} value={c.id}>
            {c.title}
          </option>
        ))}
      </select>
    </label>
  );
}
